import { Component, OnInit } from "@angular/core";
import { UtilsService } from "app/auth/service/utils.service";
import { CostService } from "app/modules/cost/cost.service";
import { IProviderCost } from "app/modules/cost/models/provider-cost";

@Component({
  selector: "app-cost-standby",
  templateUrl: "./cost-standby.component.html",
  styleUrls: ["./cost-standby.component.scss"],
})
export class CostStandbyComponent implements OnInit {
  public employeeList: any = [];

  constructor(
    public _utilsService: UtilsService,
    private _costService: CostService,
  ) {}
  async ngOnInit() {
    if (!!this._utilsService.themeConfiguration.commission_standby_employee) {
      const cost: IProviderCost = await this._costService.getStructureCostSingle(this._utilsService.themeConfiguration.commission_standby_employee);
      if (cost && cost.children && cost.children.length > 0) {
        this.employeeList = cost.children;
      }
    }
  }
}
